import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { CmsSsbtBoBootstrapResponse } from '@nsftx/seven-client-retail-vue-sgp'

export const useCmsConfigStore = defineStore('cmsConfigStore', () => {
  const cmsConfig = ref<CmsSsbtBoBootstrapResponse | null>(null)

  const setCmsConfig = (config: CmsSsbtBoBootstrapResponse) => {
    cmsConfig.value = config
  }

  return {
    cmsConfig,
    setCmsConfig
  }
})
